import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

import { AppLayoutComponent } from './app-layout/app-layout.component';

import { SidebarComponent } from './sidebar/sidebar.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { AccordionDirective } from './sidemenu/accordion.directive';
import { AccordionItemDirective } from './sidemenu/accordionItem.directive';
import { AccordionAnchorDirective } from './sidemenu/accordionanchor.directive';

import { TopmenuComponent } from './topmenu/topmenu.component';

import { HeaderComponent } from './header/header.component';
import { BrandingComponent } from './header/widgets/branding.component';
import { TranslateComponent } from './header/widgets/translate.component';
import { UserComponent } from './header/widgets/user/user.component';
import { HeaderItemsComponent } from './header/widgets/edbHeaderItems/HeaderItems.component';
import { IAccordionDirectiveInjectionToken } from './sidemenu/iAccordionDirective';
import { MenuProfileComponent } from './menu-elements/menu-profile/menu-profile.component';
import { FooterComponent } from './footer/footer.component';
import { MenuLanguageComponent } from './menu-elements/menu-language/menu-language.component';

@NgModule({
  declarations: [
    AppLayoutComponent,
    SidebarComponent,
    SidemenuComponent,
    AccordionDirective,
    AccordionItemDirective,
    AccordionAnchorDirective,
    TopmenuComponent,
    HeaderComponent,
    BrandingComponent,
    TranslateComponent,
    UserComponent,
    HeaderItemsComponent,
    MenuProfileComponent,
    FooterComponent,
    MenuLanguageComponent,
  ],
  imports: [SharedModule],
  providers: [{ provide: IAccordionDirectiveInjectionToken, useClass: AccordionDirective }],
})
export class ThemeModule {}
